import React from 'react'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TextValue from '../../../../text/TextValue'
import TextNotAssigned from '../../../../text/TextNotAssigned'
import { Typography } from '@mui/material'
import { getValueElement, printKey } from '../TableCompare/utils'

const BatchUpdate = ({ detail = {}, module }) => {
  const { fields, newData, oldData } = detail?.batch || {}

  return (
    <>
      {module !== 'user' && (
        <TextValue title='Curriculum' value={detail?.curriculum || <TextNotAssigned />} />
      )}

      <div className='py-1' />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{module}</TableCell>
              <TableCell>Old value</TableCell>
              <TableCell>New value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields?.length > 0 ? (
              fields.map((field, index) => {
                const findNew = newData?.find((item) => item._id === field._id) || {}
                const findOld = oldData?.find((item) => item._id === field._id) || {}

                return (
                  <TableRow key={`table-columd-body-${field}-${index}`}>
                    <TableCell width={100} className='overflow-hidden'>
                      <Typography variant='inherit' className='font-bold text-sm' color='primary'>
                        {field.code || field.name}
                      </Typography>
                      {module === 'user' ? (
                        <Typography variant='inherit' className='text-xs'>
                          {field?.roles?.map((item) => item.name).join(', ')}
                        </Typography>
                      ) : (
                        <Typography variant='inherit' className='text-xs'>
                          {field?.yearLevel?.map((item) => item.name).join(', ')}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell className='overflow-hidden max-w-200px'>
                      {Object.keys(findOld)
                        .filter((key) => key !== '_id')
                        .map((key) => (
                          <div
                            key={`table-columd-body-${field}-${index}-${key}`}
                            className='flex gap-1 items-center'
                          >
                            <Typography
                              component={'span'}
                              variant='inherit'
                              className='font-bold text-sm'
                              color='primary'
                            >
                              {printKey(key)}
                            </Typography>
                            <Typography component={'span'} variant='inherit' className='text-sm'>
                              {getValueElement(findOld[key], key)}
                            </Typography>
                          </div>
                        ))}
                    </TableCell>
                    <TableCell className='overflow-hidden max-w-200px'>
                      {Object.keys(findNew)
                        .filter((key) => key !== '_id')
                        .map((key) => (
                          <div
                            key={`table-columd-body-${field}-${index}-${key}`}
                            className='flex gap-1 items-center'
                          >
                            <Typography
                              component={'span'}
                              variant='inherit'
                              className='font-bold text-sm'
                              color='primary'
                            >
                              {printKey(key)}
                            </Typography>
                            <Typography component={'span'} variant='inherit' className='text-sm'>
                              {getValueElement(findNew[key], key)}
                            </Typography>
                          </div>
                        ))}
                    </TableCell>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography
                    color='inherit'
                    component={'p'}
                    className='text-muted-foreground opacity-50 py-2 text-center'
                  >
                    {"You don't have any changes yet"}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default BatchUpdate
